/** LoadError: how every card, table and sheet says its data did not load. One wording and one way out; a 403 is not a failure to retry, so it reads "Not available for your role". */
import { isPermissionDenied } from "../../api/client";
import { Button, EmptyState } from "../kit";

interface LoadErrorProps {
  /** The query's error: a 403 changes the wording and drops the retry. */
  error?: unknown;
  onRetry: () => void;
  className?: string;
}

export function LoadError({ error, onRetry, className }: LoadErrorProps) {
  if (isPermissionDenied(error)) return <EmptyState role="alert" icon="user-card" title="Not available for your role" className={className} />;
  return (
    <EmptyState role="alert" icon="feed-alert" title="Did not load" className={className}>
      <Button variant="surface" size="sm" onClick={onRetry}>
        Try again
      </Button>
    </EmptyState>
  );
}
